import _ from 'underscore';
import OrdersActionCreators from '../../../actions/OrdersActionCreators';

import {
  getStopTypes,
  getStopLocationTypes,
  mapRequiresEquipment,
} from '../../../config/stops';

import {
  DEFAULT_LOCATION,
} from '../../../config/locations';

export const orderHazMat = (order) => {
  const {
    hazmat_class,
    hazmat_description,
    hazmat_packaging_group,
  } = order;
  if (
    (hazmat_class && hazmat_class !== 'N/A') ||
    (hazmat_packaging_group && hazmat_packaging_group !== 'N/A') ||
    hazmat_description
  ) {
    return true;
  }
  return false;
};

export const mapGenerateStop = (order, equipment) => {
  const locations = getStopLocationTypes(order);
  const stopTypes = getStopTypes(order);
  const requiresEquipment = mapRequiresEquipment(order);
  const hasEquipment = !_.isEmpty(equipment);
  const isHazardous = orderHazMat(order);

  return (sequence) => {
    const {
      action,
      empty,
    } = stopTypes[sequence - 1];

    const locType = locations[sequence - 1];
    const stop = {
      action,
      empty,
      sequence,
      window_start: null,
      window_end: null,
      appointment: false,
    };

    if (hasEquipment && requiresEquipment(sequence)) {
      stop.equipments = [equipment];
    }

    if (order[locType] && order[locType].length) {
      const location = order[locType][0];
      stop.location = {
        name: location.name || '',
        address: location.address,
      };
      stop.contacts = location.contact ? [location.contact] : [];
    } else {
      // TODO: we should probably just show a link that says 'add location' if there isn't one
      // using this as a quick workaround for the short term
      stop.location = { ...DEFAULT_LOCATION };
    }

    if (isHazardous) {
      stop.hazards = [
        {
          imo_class: order.hazmat_class,
          packing_group: order.hazmat_packaging_group,
          description: order.hazmat_description,
        },
      ];
    }

    return stop;
  };
};

export const createShipment = (props, options) => {
  OrdersActionCreators.createShipmentFromOrder(props.order._id, options);
};
